import { IconComponentProps } from '@typings';

export const ListViewProducts = (props: IconComponentProps) => {
  return (
    <svg viewBox="0 0 242 202" fill="none" {...props}>
      <g filter="url(#prefix__filter0_f_1570_7803)">
        <rect x={1} y={1} width={240} height={65} rx={1.25} fill="#fff" />
        <g clipPath="url(#prefix__clip0_1570_7803)">
          <rect x={6} y={1} width={44.731} height={65} rx={1.118} fill="#fff" />
          <rect x={6} y={3.796} width={44.731} height={59.409} rx={1.118} fill="#F6F6F6" />
          <g filter="url(#prefix__filter1_f_1570_7803)" fill="#E5E5E5">
            <path d="M41.106 29.831l-14.503-6.997a.336.336 0 00-.451.159l-3.157 6.671h1.72l2.317-4.902 12.573 6.066-3.932 8.31-2.213-1.066v4.393l1.36.657c.17.083.372.008.453-.162l5.993-12.675a.34.34 0 00-.16-.454z" />
            <path d="M32.113 30.47H16.04a.341.341 0 00-.34.34v14.048c0 .188.154.342.34.342h16.072c.188 0 .34-.154.34-.342V30.81a.34.34 0 00-.339-.34zm-.928 10.765h-1.019c-.593-1.536-1.323-3.687-2.432-3.4-1.299.335-1.948 3.4-1.948 3.4s-.665-3.459-2.498-5.31c-1.833-1.852-3.61 5.31-3.61 5.31h-2.427v-9.212h13.934v9.212z" />
            <path d="M19.5 35.148c.628 0 1.137-.514 1.137-1.148 0-.634-.51-1.148-1.137-1.148-.628 0-1.137.514-1.137 1.148 0 .634.509 1.148 1.137 1.148zM27.127 34.81c.255 0 .494-.026.707-.069.248.106.55.17.875.17.84 0 1.518-.413 1.518-.923s-.678-.923-1.518-.923c-.314 0-.605.058-.847.159a.542.542 0 00-.382-.16h-.22a.542.542 0 00-.535.49c-.678.072-1.183.32-1.183.616 0 .354.71.64 1.585.64z" />
          </g>
        </g>
        <path d="M55.731 1H236v60.875c0 .69-.56 1.25-1.25 1.25H56.981c-.69 0-1.25-.56-1.25-1.25V1z" fill="#fff" />
        <rect x={58.856} y={4.125} width={12} height={3} rx={1.5} fill="#E5E5E5" />
        <rect x={58.856} y={8.125} width={11} height={2} rx={1} fill="#E5E5E5" />
        <rect x={58.856} y={14.125} width={14} height={2} rx={1} fill="#E5E5E5" />
        <rect x={58.856} y={18.125} width={15} height={2} rx={1} fill="#E5E5E5" />
        <rect x={87.763} y={14.125} width={17} height={2} rx={1} fill="#E5E5E5" />
        <rect x={87.763} y={18.125} width={11} height={2} rx={1} fill="#E5E5E5" />
        <rect x={116.669} y={14.125} width={23} height={2} rx={1} fill="#E5E5E5" />
        <rect x={116.669} y={18.125} width={18} height={2} rx={1} fill="#E5E5E5" />
        <rect x={58.778} y={26.047} width={174.175} height={34.031} rx={1.328} fill="#fff" />
        <rect x={58.778} y={26.047} width={174.175} height={34.031} rx={1.328} stroke="#E5E5E5" strokeWidth={0.156} />
        <path
          d="M58.856 27.375c0-.69.56-1.25 1.25-1.25h171.519c.69 0 1.25.56 1.25 1.25v3.156c0 .26-.21.469-.469.469H59.325a.469.469 0 01-.469-.469v-3.156z"
          fill="#F6F6F6"
        />
        <rect x={60.106} y={27.063} width={37} height={3} rx={1.5} fill="#E5E5E5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M230.317 28.213a.08.08 0 01.116 0l.543.577a.09.09 0 010 .122.078.078 0 01-.115 0l-.486-.516-.486.516a.078.078 0 01-.115 0 .09.09 0 010-.122l.543-.577z"
          fill="#666"
        />
        <g clipPath="url(#prefix__clip1_1570_7803)">
          <rect x={63.856} y={33.5} width={27} height={2} rx={1} fill="#E5E5E5" />
          <path
            d="M63.856 37.13a.63.63 0 01.63-.63h6.24a.63.63 0 01.63.63v7.177a.63.63 0 01-.63.63h-6.24a.63.63 0 01-.63-.63V37.13zM73.231 36.5h9v2h-9zM73.231 39.5h25.625v2H73.231zM73.231 42.5h15v2h-15z"
            fill="#E5E5E5"
          />
          <rect x={101.356} y={33.5} width={6.094} height={2} rx={1} fill="#E5E5E5" />
          <rect x={101.356} y={36.5} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={108.075} y={33.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={108.075} y={36.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={114.95} y={33.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={114.95} y={36.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={121.825} y={33.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={121.825} y={36.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={128.7} y={33.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={128.7} y={36.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={135.575} y={33.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={135.575} y={36.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={142.45} y={33.5} width={6.094} height={2} rx={1} fill="#E5E5E5" />
          <rect x={142.45} y={36.5} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={150.543} y={33.5} width={11.563} height={2} rx={1} fill="#E5E5E5" />
          <g clipPath="url(#prefix__clip2_1570_7803)">
            <rect x={150.543} y={36.75} width={11.563} height={8.594} rx={1.25} fill="#fff" />
            <rect x={150.543} y={37.547} width={10} height={3} rx={1.5} fill="#E5E5E5" />
            <rect x={150.543} y={41.547} width={7} height={3} rx={1.5} fill="#E5E5E5" />
          </g>
        </g>
        <g clipPath="url(#prefix__clip3_1570_7803)">
          <path
            d="M63.856 46.568a.63.63 0 01.63-.63h6.24a.63.63 0 01.63.63v7.177a.63.63 0 01-.63.63h-6.24a.63.63 0 01-.63-.63v-7.177zM73.231 45.938h9v2h-9zM73.231 48.938h25.625v2H73.231zM73.231 51.938h15v2h-15z"
            fill="#E5E5E5"
          />
          <rect x={101.356} y={45.938} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={108.075} y={45.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={114.95} y={45.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={121.825} y={45.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={128.7} y={45.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={135.575} y={45.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={142.45} y={45.938} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <g clipPath="url(#prefix__clip4_1570_7803)">
            <rect x={150.543} y={45.938} width={11.25} height={8.594} rx={1.25} fill="#fff" />
            <rect x={150.543} y={46.734} width={10} height={3} rx={1.5} fill="#E5E5E5" />
            <rect x={150.543} y={50.734} width={7} height={3} rx={1.5} fill="#E5E5E5" />
          </g>
        </g>
        <g clipPath="url(#prefix__clip5_1570_7803)">
          <rect x={1} y={68.5} width={240} height={65} rx={1.25} fill="#fff" />
          <g clipPath="url(#prefix__clip6_1570_7803)">
            <rect x={6} y={68.5} width={44.731} height={65} rx={1.118} fill="#fff" />
            <rect x={6} y={71.296} width={44.731} height={59.409} rx={1.118} fill="#F6F6F6" />
            <g filter="url(#prefix__filter2_f_1570_7803)" fill="#E5E5E5">
              <path d="M41.106 97.331l-14.503-6.997a.336.336 0 00-.451.159l-3.157 6.671h1.72l2.317-4.902 12.573 6.066-3.932 8.311-2.213-1.067v4.393l1.36.657c.17.083.372.008.453-.162l5.993-12.675a.34.34 0 00-.16-.454z" />
              <path d="M32.113 97.97H16.04a.341.341 0 00-.34.34v14.048c0 .188.154.342.34.342h16.072c.188 0 .34-.154.34-.342V98.31a.34.34 0 00-.339-.34zm-.928 10.765h-1.019c-.593-1.536-1.323-3.687-2.432-3.4-1.299.335-1.948 3.4-1.948 3.4s-.665-3.459-2.498-5.311c-1.833-1.851-3.61 5.311-3.61 5.311h-2.427v-9.212h13.934v9.212z" />
              <path d="M19.5 102.648c.628 0 1.137-.514 1.137-1.148 0-.634-.51-1.148-1.137-1.148-.628 0-1.137.514-1.137 1.148 0 .634.509 1.148 1.137 1.148zM27.127 102.311c.255 0 .494-.027.707-.07.248.106.55.171.875.171.84 0 1.518-.414 1.518-.924 0-.509-.678-.923-1.518-.923-.314 0-.605.058-.847.159a.544.544 0 00-.382-.159h-.22a.542.542 0 00-.535.49c-.678.071-1.183.32-1.183.615 0 .354.71.641 1.585.641z" />
            </g>
          </g>
          <path d="M55.731 68.5H236v60.875c0 .69-.56 1.25-1.25 1.25H56.981c-.69 0-1.25-.56-1.25-1.25V68.5z" fill="#fff" />
          <rect x={58.856} y={71.625} width={12} height={3} rx={1.5} fill="#E5E5E5" />
          <rect x={58.856} y={75.625} width={11} height={2} rx={1} fill="#E5E5E5" />
          <rect x={58.856} y={81.625} width={14} height={2} rx={1} fill="#E5E5E5" />
          <rect x={58.856} y={85.625} width={15} height={2} rx={1} fill="#E5E5E5" />
          <rect x={87.763} y={81.625} width={17} height={2} rx={1} fill="#E5E5E5" />
          <rect x={87.763} y={85.625} width={11} height={2} rx={1} fill="#E5E5E5" />
          <rect x={116.669} y={81.625} width={23} height={2} rx={1} fill="#E5E5E5" />
          <rect x={116.669} y={85.625} width={18} height={2} rx={1} fill="#E5E5E5" />
          <rect x={58.778} y={93.547} width={174.175} height={34.031} rx={1.328} fill="#fff" />
          <rect x={58.778} y={93.547} width={174.175} height={34.031} rx={1.328} stroke="#E5E5E5" strokeWidth={0.156} />
          <path
            d="M58.856 94.875c0-.69.56-1.25 1.25-1.25h171.519c.69 0 1.25.56 1.25 1.25v3.156c0 .26-.21.469-.469.469H59.325a.469.469 0 01-.469-.469v-3.156z"
            fill="#F6F6F6"
          />
          <rect x={60.106} y={94.563} width={37} height={3} rx={1.5} fill="#E5E5E5" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M230.317 95.713a.08.08 0 01.116 0l.543.577a.09.09 0 010 .122.078.078 0 01-.115 0l-.486-.516-.486.516a.078.078 0 01-.115 0 .09.09 0 010-.122l.543-.577z"
            fill="#666"
          />
          <g clipPath="url(#prefix__clip7_1570_7803)">
            <rect x={63.856} y={101} width={27} height={2} rx={1} fill="#E5E5E5" />
            <path
              d="M63.856 104.63a.63.63 0 01.63-.63h6.24a.63.63 0 01.63.63v7.177a.631.631 0 01-.63.631h-6.24a.631.631 0 01-.63-.631v-7.177zM73.231 104h9v2h-9zM73.231 107h25.625v2H73.231zM73.231 110h15v2h-15z"
              fill="#E5E5E5"
            />
            <rect x={101.356} y={101} width={6.094} height={2} rx={1} fill="#E5E5E5" />
            <rect x={101.356} y={104} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={108.075} y={101} width={6.25} height={2} rx={1} fill="#E5E5E5" />
            <rect x={108.075} y={104} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={114.95} y={101} width={6.25} height={2} rx={1} fill="#E5E5E5" />
            <rect x={114.95} y={104} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={121.825} y={101} width={6.25} height={2} rx={1} fill="#E5E5E5" />
            <rect x={121.825} y={104} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={128.7} y={101} width={6.25} height={2} rx={1} fill="#E5E5E5" />
            <rect x={128.7} y={104} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={135.575} y={101} width={6.25} height={2} rx={1} fill="#E5E5E5" />
            <rect x={135.575} y={104} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={142.45} y={101} width={6.094} height={2} rx={1} fill="#E5E5E5" />
            <rect x={142.45} y={104} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={150.543} y={101} width={11.563} height={2} rx={1} fill="#E5E5E5" />
            <g clipPath="url(#prefix__clip8_1570_7803)">
              <rect x={150.543} y={104.25} width={11.563} height={8.594} rx={1.25} fill="#fff" />
              <rect x={150.543} y={105.047} width={10} height={3} rx={1.5} fill="#E5E5E5" />
              <rect x={150.543} y={109.047} width={7} height={3} rx={1.5} fill="#E5E5E5" />
            </g>
          </g>
          <g clipPath="url(#prefix__clip9_1570_7803)">
            <path
              d="M63.856 114.068a.63.63 0 01.63-.63h6.24a.63.63 0 01.63.63v7.177a.63.63 0 01-.63.63h-6.24a.63.63 0 01-.63-.63v-7.177zM73.231 113.438h9v2h-9zM73.231 116.438h25.625v2H73.231zM73.231 119.438h15v2h-15z"
              fill="#E5E5E5"
            />
            <rect x={101.356} y={113.438} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={108.075} y={113.438} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={114.95} y={113.438} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={121.825} y={113.438} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={128.7} y={113.438} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={135.575} y={113.438} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
            <rect x={142.45} y={113.438} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
            <g clipPath="url(#prefix__clip10_1570_7803)">
              <rect x={150.543} y={113.438} width={11.25} height={8.594} rx={1.25} fill="#fff" />
              <rect x={150.543} y={114.234} width={10} height={3} rx={1.5} fill="#E5E5E5" />
              <rect x={150.543} y={118.234} width={7} height={3} rx={1.5} fill="#E5E5E5" />
            </g>
          </g>
        </g>
        <rect x={1} y={136} width={240} height={65} rx={1.25} fill="#fff" />
        <g clipPath="url(#prefix__clip11_1570_7803)">
          <rect x={6} y={136} width={44.731} height={65} rx={1.118} fill="#fff" />
          <rect x={6} y={138.796} width={44.731} height={59.409} rx={1.118} fill="#F6F6F6" />
          <g filter="url(#prefix__filter3_f_1570_7803)" fill="#E5E5E5">
            <path d="M41.106 164.831l-14.503-6.997a.336.336 0 00-.451.159l-3.157 6.671h1.72l2.317-4.902 12.573 6.066-3.932 8.311-2.213-1.067v4.393l1.36.657c.17.083.372.008.453-.162l5.993-12.675a.34.34 0 00-.16-.454z" />
            <path d="M32.113 165.47H16.04a.342.342 0 00-.34.34v14.048c0 .188.154.342.34.342h16.072c.188 0 .34-.154.34-.342V165.81a.34.34 0 00-.339-.34zm-.928 10.765h-1.019c-.593-1.536-1.323-3.687-2.432-3.4-1.299.335-1.948 3.4-1.948 3.4s-.665-3.459-2.498-5.311c-1.833-1.851-3.61 5.311-3.61 5.311h-2.427v-9.212h13.934v9.212z" />
            <path d="M19.5 170.148c.628 0 1.137-.514 1.137-1.148 0-.634-.51-1.148-1.137-1.148-.628 0-1.137.514-1.137 1.148 0 .634.509 1.148 1.137 1.148zM27.127 169.811c.255 0 .494-.027.707-.07.248.106.55.171.875.171.84 0 1.518-.414 1.518-.924 0-.509-.678-.923-1.518-.923-.314 0-.605.058-.847.159a.544.544 0 00-.382-.159h-.22a.542.542 0 00-.535.49c-.678.071-1.183.32-1.183.615 0 .354.71.641 1.585.641z" />
          </g>
        </g>
        <path d="M55.731 136H236v60.875c0 .69-.56 1.25-1.25 1.25H56.981c-.69 0-1.25-.56-1.25-1.25V136z" fill="#fff" />
        <rect x={58.856} y={139.125} width={12} height={3} rx={1.5} fill="#E5E5E5" />
        <rect x={58.856} y={143.125} width={11} height={2} rx={1} fill="#E5E5E5" />
        <rect x={58.856} y={149.125} width={14} height={2} rx={1} fill="#E5E5E5" />
        <rect x={58.856} y={153.125} width={15} height={2} rx={1} fill="#E5E5E5" />
        <rect x={87.763} y={149.125} width={17} height={2} rx={1} fill="#E5E5E5" />
        <rect x={87.763} y={153.125} width={11} height={2} rx={1} fill="#E5E5E5" />
        <rect x={116.669} y={149.125} width={23} height={2} rx={1} fill="#E5E5E5" />
        <rect x={116.669} y={153.125} width={18} height={2} rx={1} fill="#E5E5E5" />
        <rect x={58.778} y={161.047} width={174.175} height={34.031} rx={1.328} fill="#fff" />
        <rect x={58.778} y={161.047} width={174.175} height={34.031} rx={1.328} stroke="#E5E5E5" strokeWidth={0.156} />
        <path
          d="M58.856 162.375c0-.69.56-1.25 1.25-1.25h171.519c.69 0 1.25.56 1.25 1.25v3.156c0 .259-.21.469-.469.469H59.325a.469.469 0 01-.469-.469v-3.156z"
          fill="#F6F6F6"
        />
        <rect x={60.106} y={162.062} width={37} height={3} rx={1.5} fill="#E5E5E5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M230.317 163.213a.079.079 0 01.116 0l.543.577a.09.09 0 010 .122.078.078 0 01-.115 0l-.486-.516-.486.516a.078.078 0 01-.115 0 .09.09 0 010-.122l.543-.577z"
          fill="#666"
        />
        <g clipPath="url(#prefix__clip12_1570_7803)">
          <rect x={63.856} y={168.5} width={27} height={2} rx={1} fill="#E5E5E5" />
          <path
            d="M63.856 172.13a.63.63 0 01.63-.63h6.24a.63.63 0 01.63.63v7.177a.631.631 0 01-.63.631h-6.24a.631.631 0 01-.63-.631v-7.177zM73.231 171.5h9v2h-9zM73.231 174.5h25.625v2H73.231zM73.231 177.5h15v2h-15z"
            fill="#E5E5E5"
          />
          <rect x={101.356} y={168.5} width={6.094} height={2} rx={1} fill="#E5E5E5" />
          <rect x={101.356} y={171.5} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={108.075} y={168.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={108.075} y={171.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={114.95} y={168.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={114.95} y={171.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={121.825} y={168.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={121.825} y={171.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={128.7} y={168.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={128.7} y={171.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={135.575} y={168.5} width={6.25} height={2} rx={1} fill="#E5E5E5" />
          <rect x={135.575} y={171.5} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={142.45} y={168.5} width={6.094} height={2} rx={1} fill="#E5E5E5" />
          <rect x={142.45} y={171.5} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={150.543} y={168.5} width={11.563} height={2} rx={1} fill="#E5E5E5" />
          <g clipPath="url(#prefix__clip13_1570_7803)">
            <rect x={150.543} y={171.75} width={11.563} height={8.594} rx={1.25} fill="#fff" />
            <rect x={150.543} y={172.547} width={10} height={3} rx={1.5} fill="#E5E5E5" />
            <rect x={150.543} y={176.547} width={7} height={3} rx={1.5} fill="#E5E5E5" />
          </g>
        </g>
        <g clipPath="url(#prefix__clip14_1570_7803)">
          <path
            d="M63.856 181.568a.63.63 0 01.63-.63h6.24a.63.63 0 01.63.63v7.177a.63.63 0 01-.63.63h-6.24a.63.63 0 01-.63-.63v-7.177zM73.231 180.938h9v2h-9zM73.231 183.938h25.625v2H73.231zM73.231 186.938h15v2h-15z"
            fill="#E5E5E5"
          />
          <rect x={101.356} y={180.938} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={108.075} y={180.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={114.95} y={180.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={121.825} y={180.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={128.7} y={180.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={135.575} y={180.938} width={6.25} height={8.438} rx={1.25} fill="#F6F6F6" />
          <rect x={142.45} y={180.938} width={6.094} height={8.438} rx={1.25} fill="#F6F6F6" />
          <g clipPath="url(#prefix__clip15_1570_7803)">
            <rect x={150.543} y={180.938} width={11.25} height={8.594} rx={1.25} fill="#fff" />
            <rect x={150.543} y={181.734} width={10} height={3} rx={1.5} fill="#E5E5E5" />
            <rect x={150.543} y={185.734} width={7} height={3} rx={1.5} fill="#E5E5E5" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="prefix__clip0_1570_7803">
          <rect x={6} y={1} width={44.731} height={65} rx={1.118} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip1_1570_7803">
          <path fill="#fff" transform="translate(62.606 33.5)" d="M0 0h166.519v12.438H0z" />
        </clipPath>
        <clipPath id="prefix__clip2_1570_7803">
          <rect x={150.543} y={36.75} width={11.563} height={8.594} rx={1.25} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip3_1570_7803">
          <path fill="#fff" transform="translate(62.606 45.938)" d="M0 0h166.519v10.938H0z" />
        </clipPath>
        <clipPath id="prefix__clip4_1570_7803">
          <rect x={150.543} y={45.938} width={11.25} height={8.594} rx={1.25} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip5_1570_7803">
          <rect x={1} y={68.5} width={240} height={65} rx={1.25} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip6_1570_7803">
          <rect x={6} y={68.5} width={44.731} height={65} rx={1.118} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip7_1570_7803">
          <path fill="#fff" transform="translate(62.606 101)" d="M0 0h166.519v12.438H0z" />
        </clipPath>
        <clipPath id="prefix__clip8_1570_7803">
          <rect x={150.543} y={104.25} width={11.563} height={8.594} rx={1.25} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip9_1570_7803">
          <path fill="#fff" transform="translate(62.606 113.438)" d="M0 0h166.519v10.938H0z" />
        </clipPath>
        <clipPath id="prefix__clip10_1570_7803">
          <rect x={150.543} y={113.438} width={11.25} height={8.594} rx={1.25} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip11_1570_7803">
          <rect x={6} y={136} width={44.731} height={65} rx={1.118} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip12_1570_7803">
          <path fill="#fff" transform="translate(62.606 168.5)" d="M0 0h166.519v12.438H0z" />
        </clipPath>
        <clipPath id="prefix__clip13_1570_7803">
          <rect x={150.543} y={171.75} width={11.563} height={8.594} rx={1.25} fill="#fff" />
        </clipPath>
        <clipPath id="prefix__clip14_1570_7803">
          <path fill="#fff" transform="translate(62.606 180.938)" d="M0 0h166.519v10.938H0z" />
        </clipPath>
        <clipPath id="prefix__clip15_1570_7803">
          <rect x={150.543} y={180.938} width={11.25} height={8.594} rx={1.25} fill="#fff" />
        </clipPath>
        <filter
          id="prefix__filter0_f_1570_7803"
          x={0}
          y={0}
          width={242}
          height={202}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={0.5} result="effect1_foregroundBlur_1570_7803" />
        </filter>
        <filter
          id="prefix__filter1_f_1570_7803"
          x={11.9}
          y={17.4}
          width={33.2}
          height={33.2}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={0.3} result="effect1_foregroundBlur_1570_7803" />
        </filter>
        <filter
          id="prefix__filter2_f_1570_7803"
          x={11.9}
          y={84.9}
          width={33.2}
          height={33.2}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={0.3} result="effect1_foregroundBlur_1570_7803" />
        </filter>
        <filter
          id="prefix__filter3_f_1570_7803"
          x={11.9}
          y={152.4}
          width={33.2}
          height={33.2}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation={0.3} result="effect1_foregroundBlur_1570_7803" />
        </filter>
      </defs>
    </svg>
  );
};
